import React, { useState, useRef, useEffect  } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Card } from "primereact/card";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import Sidebar from "../Common/Sidebar";
import axios from "axios";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css'; 
import 'react-h5-audio-player/lib/styles.css';
import Loader from "../Common/Loader";
import AskAlexandriaImg from "../assets/images/AskAI.png"
import AskAlexandria from "./AskAlexandria";

export default function SupportCallAnalysis() {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams(); 
  const [showTranscription, setShowTranscription] = useState(false);
  const [showWideSidebar, setShowWideSidebar] = useState(true);
  const [data, setData] = useState<any>(null);
  const printContentRef = useRef<HTMLDivElement>(null);
  const [audioFile, setAudioFile] = useState<string | null>(null);
  const [audioLoading, setAudioLoading] = useState(false);
  const [showAskAlexDialog, setShowAskAlexDialog] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleBackClick = () => {
    navigate("/supportcall", { state: { filters: location.state?.filters } });
  };

 const handleTranscriptionClick = () => {
  if (data?.id) {
    fetchAudio(data.id);
  }
  setShowTranscription(true);
};


  const generatePDF = () => {
    const content = printContentRef.current;
    if (content) {
      html2canvas(content, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const imgHeight = (canvas.height * pdfWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;
        pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
        heightLeft -= pdfHeight;
        while (heightLeft > 0) {
          position = heightLeft - imgHeight;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 0, position, pdfWidth, imgHeight);
          heightLeft -= pdfHeight;
        }
        pdf.save(`${data.userName || "report"}.pdf`);
      });
    }
  }
  const fetchAudio = async (id: number) => {
    
  try {
    const token = localStorage.getItem("igtoken");
    const response = await axios.get(
      `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/SupportCallHistory/audio/${id}`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const audioBlobUrl = URL.createObjectURL(response.data);
    setAudioFile(audioBlobUrl);
  } catch (error) {
    setAudioFile(null);
  } finally {
    
  }
};

  const onSidebarValueChanged = (value: any) => {
    setShowWideSidebar(value);

  };

  useEffect(() => {
    if (!id) {
      navigate("/supportcall");
      return;
    }
    
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("igtoken");
        const response = await axios.get(
          `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/support-call-analysis/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        if (response.data?.success) {
          setData(response.data.data || {});
        } else {
          navigate("/supportcall");
        }
      } catch (error) {

        navigate("/supportcall");
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, [id, navigate]); 
   
  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar pagename="supportcall" onSidebarValueChanged={onSidebarValueChanged} />
      
      {loading ? (
        <div className="flex-grow-1 d-flex justify-content-center align-items-center">
          <Loader />
        </div>
      ) : !data ? (
        <div className="flex-grow-1 d-flex justify-content-center align-items-center">
          <p>No data available</p>
        </div>
      ) : (
        <div className="flex-grow-1 d-flex flex-column bg-light p-2 mt-4">
        <div className={`${showWideSidebar
          ? "main-content-large-width"
          : "main-content-small-width"}`}>
          <div>
            <h2 className="fw-bold">Call Analysis Dashboard </h2>
            <p className="text-muted"></p>
          </div>
          <div className="card py-4 px-4"
            style={{ fontFamily: "'Segoe UI', 'Inter', sans-serif", fontSize: "14px", }}>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <Button
                icon="fa fa-arrow-left"
                className="p-button curved-button primary-btn"
                onClick={handleBackClick}
              />
              <div className="d-flex gap-3">
                 <Button
                  icon={<img src={AskAlexandriaImg} alt="Ask" style={{ width: '22px', height: '22px', marginRight: '6px' ,filter: 'invert(39%) sepia(81%) saturate(1500%) hue-rotate(270deg) brightness(70%) contrast(150%)'}} />}
                  label="Ask Alexandria"
                  className="p-button curved-button Alex-button"
                  title="Ask Alexandria"
                  onClick={() => setShowAskAlexDialog(true)}
                />
                <Button
                  icon="fa fa-address-book"
                  label="See Call Transcription"
                  onClick={handleTranscriptionClick}
                  className="p-button curved-button btn-transcription"
                />
                <Button
                  icon="fa fa-file-pdf"
                  label="Generate PDF"
                  onClick={generatePDF}
                  className="p-button curved-button primary-btn"
                />
              </div>
            </div>
            <div ref={printContentRef} className="bg-white rounded shadow-sm">
              <div className="row g-2 d-flex">
                <div className="col-md-3 d-flex">
                  <Card className="text-start w-100 h-100 info-block shadow-hover rounded-4 ">
                    <p className="body-text">
                       <h6 className="text-purple fw-semibold mb-3 title-heading">
                         User Name
                       </h6>
                      <p className="text-dark m-2 body-content">{data.userName}</p>
                    </p>
                     <h6 className="text-purple fw-semibold mb-3 title-heading">
                        Team Name
                       </h6>
                      <p className="text-dark m-2 body-content">{data.team}</p>
                  </Card>
                </div>
                <div className="col-md-2 d-flex">
                  <Card className="text-start w-100 h-100 info-block shadow-hover rounded-4">
                    <p className="body-text">
                     <h6 className="text-purple fw-semibold mb-3 title-heading">
                        Call Occured
                       </h6>
                      <p className="text-dark m-2 body-content">{data.callOccured}</p>
                    </p>
                    <p className="body-text">
                       <h6 className="text-purple fw-semibold mb-3 title-heading">
                         Caller Number
                       </h6>
                      <p className="text-dark m-2 body-content">{data.callWith}</p>
                    </p>
                  </Card>
                </div>
                <div className="col-md-2 d-flex">
                  <Card className="text-start w-100 h-100 info-block shadow-hover rounded-4">
                    <p className="body-text">
                      <h6 className="text-purple fw-semibold mb-3 title-heading">
                         Direction
                       </h6>
                      <p className="text-dark m-2 body-content">{data.direction}</p>
                    </p>
                    <p className="body-text">
                      <h6 className="text-purple fw-semibold mb-3 title-heading">
                        Tag
                       </h6>
                      <p className="text-dark m-2 body-content">{data.tag}</p>
                    </p>
                  </Card>
                </div>
                <div className="col-md-2 d-flex">
                  <Card className="text-start w-100 h-100 d-flex flex-column align-items-start info-block shadow-hover rounded-4">
                    <p className="body-text">
                     <h6 className="text-purple fw-semibold mb-3 title-heading">
                      Status
                       </h6>
                      <p className="text-dark m-2 body-content">{data.actionTaken}</p>
                    </p>
                  </Card>
                </div>
                <div className="col-md-3 d-flex">
                  <Card className="w-100 h-100 d-flex flex-column justify-content-center align-items-center shadow-hover rounded-4 info-block call-score-card">
                     <div className="call-score-wrapper mb-3">
                      <CircularProgressbar
                         value={data.analysisScore}
                           maxValue={10}
                            text={`${data.analysisScore}`}
                             styles={buildStyles({
                                 textColor: "#6f42c1",
                                 pathColor: "#A200FF",
                                 trailColor: "#e6dbff",
                                 textSize: "38px",
                                 pathTransitionDuration: 0.5,
                                })}
                               />
                     </div>
                       <span className="call-score-label title-heading text-center">
                         <i className="me-2"></i>Call Analysis Score
                      </span>
                 </Card>
                </div>
              </div>
              <Card className="my-3 info-block shadow-hover rounded-4 ">
               <h6 className="text-purple fw-semibold mb-3 title-heading">
                         <i className="me-2"></i>Analysis Summary
                       </h6>
                      <p className="text-dark m-2 body-content">{data.analysisSummary}</p>
              </Card>
              <div className="row g-3">
                <div className="col-md-6">
                  <Card className="info-block shadow-hover rounded-4">
                    <h6 className="text-purple fw-semibold mb-3 title-heading">
                         <i className=" me-2"></i>Coustomer Issue
                       </h6>
                      <p className="text-dark m-2 body-content">{data.customerIssue}</p>
                  </Card>
                </div>
                <div className="col-md-6">
                  <Card className="info-block shadow-hover rounded-4">
                    <h6 className="text-purple fw-semibold mb-3 title-heading">
                         <i className=" me-2"></i>Desired Resolution
                       </h6>
                      <p className="text-dark m-2 body-content">{data.desiredResolution}</p>
                  </Card>
                </div>
                <div className="col-md-6">
                  <Card className="info-block shadow-hover rounded-4">
                    <h6 className="text-purple fw-semibold mb-3 title-heading">
                         <i className=" me-2"></i>Key Highlights
                       </h6>
                      <p className="text-dark m-2 body-content">{data.keyHighlights}</p>
                  </Card>
                </div>
                <div className="col-md-6">
                  <Card className="info-block shadow-hover rounded-4">
                   <h6 className="text-purple fw-semibold mb-3 title-heading">
                         <i className="me-2"></i>Actionable Recommendations
                       </h6>
                      <p className="text-dark m-2 body-content">{data.actionableRecommendations}</p>
                  </Card>
                </div>
                <div className="col-md-6 ">
                  <Card className="info-block shadow-hover rounded-4">
                      <h6 className="text-purple fw-semibold mb-3 title-heading">
                         <i className=" me-2"></i>Conversation Flow
                       </h6>
                      <p className="text-dark m-2 body-content">{data.conversationFlow}</p>
                  </Card>
                </div>
                <div className="col-md-6">
                  <Card className="info-block shadow-hover rounded-4">
                    <h6 className="text-purple fw-semibold mb-3 title-heading">
                         <i className="me-2"></i>Engagement Level
                       </h6>
                      <p className="text-dark m-2 body-content">{data.engagementLevel}</p>
                  </Card>
                </div>
                <div className="col-md-6">
                  <Card className="info-block shadow-hover rounded-4">
                     <h6 className="text-purple fw-semibold mb-3 title-heading">
                         <i className="me-2"></i>Resolution Effectiveness
                       </h6>
                      <p className="text-dark m-2 body-content">{data.resolutionEffectiveness}</p>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
       <div className="print-wrapper enhanced-print">
         <div ref={printContentRef} className="print-container bordered-container shadow-lg p-4 bg-white rounded">
            <div className="row g-4 mb-2 avoid-break">
              <div className="col-12 col-md-4">
                 <div className="info-card h-100">
                   <p><strong>User:</strong> {data.userName}</p>
                   <p><strong>Team:</strong> {data.team}</p>
                 </div>
              </div>
              <div className="col-12 col-md-4">
                 <div className="info-card h-100">
                    <p><strong>Date:</strong> {data.callOccured}</p>
                    <p><strong>Caller:</strong> {data.callWith}</p>
                 </div>
              </div>
             <div className="col-12 col-md-4 text-center">
                 <div className="score-circle-container">
                     <div className="pdfscore-circle display-5 fw-bold">{data.analysisScore}</div>
                     <div className="pdfscore-label"><strong>Score</strong></div>
                 </div>
            </div>
         </div>
         <div className="row g-4 mb-4 avoid-break">
              <div className="col-12 col-md-4">
                 <div className="info-card h-100">
                    <p><strong>Direction:</strong> {data.direction}</p>
                    <p><strong>Tag:</strong> {data.tag}</p>
                </div>
             </div>
             <div className="col-12 col-md-4">
                  <div className="info-card h-100">
                    <p><strong>Status:</strong> {data.actionTaken}</p>
                  </div>
             </div>
          </div>
          <hr className="divider my-3" />
          <div className="section mb-4 avoid-break">
             <h5 className="section-heading mb-2">🔍 Analysis Summary</h5>
               <p>{data.analysisSummary}</p>
          </div>
        <div className="row g-3 mb-4">
            {[
               { label: "🧾 Customer Issue", value: data.customerIssue },
               { label: "🎯 Desired Resolution", value: data.desiredResolution },
               { label: "💡 Key Highlights", value: data.keyHighlights },
               { label: "🛠️ Recommendations", value: data.actionableRecommendations },
               { label: "🔄 Conversation Flow", value: data.conversationFlow },
               { label: "📈 Engagement Level", value: data.engagementLevel },
               { label: "✅ Resolution Effectiveness", value: data.resolutionEffectiveness },
                  ].map((item, idx) => (
                      <div className="col-12 col-md-6 avoid-break" key={item.label}>
                          <div className="info-card p-3 border rounded bg-light h-100">
                             <h6 className="section-heading small mb-1">{item.label}</h6>
                             <p className="compact-text mb-0">{item.value}</p>
                          </div>
                      </div>
                    ))}
          </div>
             <hr className="divider my-3" />
               <p className="footer-text text-center mt-4 small text-muted"> Generated by <strong>SupportCallAnalysis</strong></p>
         </div>
       </div>
       <Dialog
           header="Transcription:"
           visible={showTranscription}
           style={{ width: "90%", maxWidth: "50%" }}
           onHide={() => setShowTranscription(false)}
           draggable={false}
           className="custom-dialog styled-dialog"
       >
       <div className="dialog-content-container">
       {audioLoading ? (
              <div className="d-flex justify-content-center">
                <Loader />
              </div>
            ) : (
          <>
           <div className="transcription-body">
              {data?.transcription ? (
                 data.transcription.split("\n").map((line: string, index: number) => (
                  <p key={index} style={{ marginBottom: "0.6rem" }}>{line}</p>
               ))
               ) : (
               <p>No Transcription Found!!</p>
              )}
            </div>
            <div className="audio-player-wrapper">
              {audioFile ? (
                <AudioPlayer
                   src={audioFile}
                   customAdditionalControls={[]}
                   customVolumeControls={[]}
                   className="custom-audio"
                />
                ) : (
                  <p style={{ fontSize: "1rem", color: "#ad15f4e1", textAlign: "center" }}>
                   Call Recording Not Found!!
                  </p>
                )}
                </div>
               </>
             )}
           </div>
        </Dialog>
        <AskAlexandria visible={showAskAlexDialog} onHide={() => setShowAskAlexDialog(false)} id={data?.id}/>
      </div>
      )}
    </div>
            
  );
}

